import { FaExclamationTriangle } from "react-icons/fa";
import DropdownItemBase from "./DropdownItemBase";

const DropdownItemFarmaco = ({ notif, onClick }) => {
    const info = notif.reporte_info;
    if (!info) return null;

    const dataAberturaRaw = notif.reporte_info?.data_cadastro;
    let dataFormatada = "";
    if (dataAberturaRaw) {
        if (dataAberturaRaw.includes('/')) {
            dataFormatada = dataAberturaRaw;
        } else {
            try {
                const data = new Date(dataAberturaRaw);
                dataFormatada = data.toLocaleString("pt-BR", {
                    day: "2-digit", month: "2-digit", year: "numeric",
                    hour: "2-digit", minute: "2-digit",
                });
            } catch (e) { dataFormatada = dataAberturaRaw; }
        }
    }

    return (
        <DropdownItemBase
            icon={<FaExclamationTriangle />}
            text="text-warning"
            titulo="Farmacovigilância"
            descricao={
                <>
                    Novo reporte de: <strong>{info.prestador_nome}</strong>
                </>
            }
            dataFormatada={dataFormatada ? `Aberto em: ${dataFormatada}` : ""}
            onClick={() => onClick(notif)}
        />
    );
};

export default DropdownItemFarmaco;
